import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { GroupDefaultProps } from 'src/containers/admin-containers/group-container/GroupPropTypes';
import { GROUP_ACTIONS } from '../actions/GroupActions';

const initialState = () => ({
    currentRecord: { ...GroupDefaultProps },

    search: {
        data: [],
        total:0,
        groupStatusCounts:{active:0,deActive:0},
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    uploadReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        
        case GROUP_ACTIONS.GROUP_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case GROUP_ACTIONS.GROUP_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case GROUP_ACTIONS.GROUP_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        
        case GROUP_ACTIONS.GROUP_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case GROUP_ACTIONS.GROUP_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case GROUP_ACTIONS.GROUP_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        } 
        
        case GROUP_ACTIONS.GROUP_RESET: {
            return {
                ...state,
                currentRecord: { ...GroupDefaultProps },
            };
        }

        default:
            return state;
    }
};
